import { render, staticRenderFns } from "./AccountJudgment.vue?vue&type=template&id=fbbfbffe&scoped=true&"
import script from "./AccountJudgment.vue?vue&type=script&lang=js&"
export * from "./AccountJudgment.vue?vue&type=script&lang=js&"
import style0 from "./AccountJudgment.vue?vue&type=style&index=0&id=fbbfbffe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbfbffe",
  null
  
)

export default component.exports